// Note: Google Tag Manager
// Date: 04/18/2020
import Script from 'next/script';

export default function GTM() {
    const GTM_ID = 'GTM-KPHHR9P';
    return (
        <>
            <Script id="google-tag-manager" strategy="lazyOnload" defer>
                {`
                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','pageMetricsDataLayer','${GTM_ID}');
              `}
            </Script>
            <noscript>
                <iframe
                    title="GTM"
                    src="https://www.googletagmanager.com/ns.html?id=GTM-KPHHR9P"
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                />
            </noscript>
        </>
    );
}
